<div class="wallet-page">
  <div class="wallet-header">
    <h1>Wallet</h1>
    <p>Your company's platform credit balance. A superadmin tops this up after money is received.</p>
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else {
    @if (wallet(); as w) {
      <div class="balance-card">
        <span class="label">Balance</span>
        <span class="balance">{{ w.balance }}</span>
        <span class="updated">Updated {{ w.updatedAt | date: 'medium' }}</span>
      </div>
    }

    <section class="transactions-section">
      <h2>Transactions</h2>

      @if (transactions().length === 0) {
        <app-empty-state message="No transactions yet." />
      } @else {
        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Amount</th>
              <th>Balance after</th>
              <th>Note</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            @for (tx of transactions(); track tx.id) {
              <tr>
                <td>{{ tx.type }}</td>
                <td [class.amount--negative]="tx.amount < 0">{{ tx.amount }}</td>
                <td>{{ tx.balanceAfter }}</td>
                <td>{{ tx.note || '—' }}</td>
                <td>{{ tx.createdAt | date: 'medium' }}</td>
              </tr>
            }
          </tbody>
        </table>

        <div class="pagination">
          <div class="page-size-control">
            <span>Results per page</span>
            <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
          </div>

          <div class="pagination-pill">
            <button class="page-nav" (click)="goToPage(page() - 1)" [disabled]="page() === 0">
              <span class="material-icons">chevron_left</span>
              Previous
            </button>
            @for (p of pageWindow; track $index) {
              @if (p === -1) {
                <span class="page-ellipsis">…</span>
              } @else {
                <button class="page-dot" [class.page-dot--active]="p === page()" (click)="goToPage(p)">
                  {{ p + 1 }}
                </button>
              }
            }
            <button class="page-nav" (click)="goToPage(page() + 1)" [disabled]="page() === totalPages() - 1">
              Next
              <span class="material-icons">chevron_right</span>
            </button>
            <span class="pagination-divider"></span>
            <span class="pagination-summary">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount() }} transactions</span>
          </div>
        </div>
      }
    </section>
  }
</div>
